import React from "react";
import styles from "./RecommendedPlan.module.css";
import { trackEvent } from "../../lib/analytics";

export default function PlanSelectionView({ showBackBtn, handleGoBack, isUpgradeFlow, setTrialModalOpen, billingInterval, setBillingInterval, loading, error, cards, selectedPlanId, getCurrencySymbol, setError, setSelectedPlanId, formatPrice, revealPlanFeatures, showComparison, comparisonRef, selectedCard, COMPARISON_ROWS, COMPARISON_COLUMNS, handleContinue, checkoutLoading, agentName }) {
 return (<div className={styles.screen}>
                <div className={styles.plansWrap}>
                    {/* Explicit way out of Choose Your Plan — see showBackBtn
                    above for which surfaces get it and why. */}
                    {/* "Go Back" pill hata diya — ab title ke aage × close button hai. */}
                    {/* Top wording: shows the "Choose Your Plan" header for the
                    first 10s, then swaps to the orange $20 trial banner.
                    Tap on the banner navigates to the 21-day trial view. */}
                    {/* {!promoVisible ? (
                    
                ) : (
                    <button
                        type="button"
                        className={styles.promoBanner}
                        onClick={goToTrial}
                    >
                        <span className={styles.promoBannerIcon}><img src="/svg/not_ready_emoji.svg" alt="not_ready_emoji"/></span>
                        <span className={styles.promoBannerBody}>
                            <h5>Not ready to commit?</h5><span> <span>Start 21-Day
                            Trial for</span> <b>$20</b> with{" "}
                            <span className={styles.promoBannerLink}>
                                Scaler Benefits
                            </span></span>
                        </span>
                        <span
                            className={styles.promoBannerClose}
                            aria-label="Dismiss"
                            onClick={(e) => {
                                e.stopPropagation();
                                setPromoVisible(false);
                            }}
                        >
                            ×
                        </span>
                    </button>
                )} */}
                    <div className={styles.titleDiv}>
                        {/* Title + subtitle ek block me — beech me plansWrap ka gap na aaye. */}
                        <div className={styles.titleBlock}>
                            <h1 className={styles.plansTitle}>Choose Your Plan</h1>
                            <p className={styles.plansSub}>Cancel anytime. No contracts.</p>
                        </div>
                        {/*
                          Cross icon opens the trial promo modal (the "$1
                          for 21 days" pitch). Only relevant for users
                          who haven't paid yet — an upgrade-flow user
                          already has a paid plan; offering them a trial
                          they can't actually claim would be misleading.
                          Hidden when isUpgradeFlow=true so the trial
                          escape hatch is gated to new-paying users.
                        */}
                        {/* Jahan back chahiye (showBackBtn) wahan × close = handleGoBack.
                            Baaki jagah pehle jaisa trial offer wala cross. Dono ek saath
                            nahi — do × confusing lagte. */}
                        {showBackBtn ? (
                            <button
                                type="button"
                                className={styles.titleCloseBtn}
                                onClick={handleGoBack}
                                aria-label="Close"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                                </svg>
                            </button>
                        ) : !isUpgradeFlow && (
                            <img src="/svg/cross_leter.svg" alt="cross_leter" onClick={() => { trackEvent("trial_offer_view"); setTrialModalOpen(true); }} />
                        )}
                    </div>

                    <div className={styles.toggleRow}>
                        <div className={styles.toggleGroup}>
                            <span
                                className={`${styles.toggleLabel} ${billingInterval === "month"
                                    ? styles.toggleLabelActive
                                    : ""
                                    }`}
                            >
                                Monthly
                            </span>
                            <button
                                type="button"
                                className={`${styles.toggleSwitch} ${billingInterval === "year"
                                    ? styles.toggleSwitchYear
                                    : ""
                                    }`}
                                onClick={() =>
                                    setBillingInterval(
                                        billingInterval === "month"
                                            ? "year"
                                            : "month"
                                    )
                                }
                                aria-label="Toggle billing interval"
                            >
                                <span className={styles.toggleKnob} />
                            </button>
                            <span
                                className={`${styles.toggleLabel} ${billingInterval === "year"
                                    ? styles.toggleLabelActive
                                    : ""
                                    }`}
                            >
                                Yearly
                            </span>
                        </div>
                        <span className={styles.savePill}>
                            Annual <strong>(Save up to 17%)</strong>
                        </span>
                    </div>

                    {loading && (
                        <div className={styles.plansList}>
                            {[0, 1, 2].map((i) => (
                                <div
                                    key={i}
                                    className={`${styles.planCard} ${styles.skeletonCard}`}
                                    aria-hidden="true"
                                >
                                    <div className={styles.planTop}>
                                        <div className={styles.planLeft}>
                                            <span
                                                className={`${styles.skel} ${styles.skelIcon}`}
                                            />
                                            <div>
                                                <span
                                                    className={`${styles.skel} ${styles.skelPrice}`}
                                                />
                                                <span
                                                    className={`${styles.skel} ${styles.skelSub}`}
                                                />
                                            </div>
                                        </div>
                                        <div className={styles.planRight}>
                                            <span
                                                className={`${styles.skel} ${styles.skelMinutes}`}
                                            />
                                            <span
                                                className={`${styles.skel} ${styles.skelRadio}`}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.planMid}>
                                        <span
                                            className={`${styles.skel} ${styles.skelName}`}
                                        />
                                        <span
                                            className={`${styles.skel} ${styles.skelLink}`}
                                        />
                                    </div>
                                    <span
                                        className={`${styles.skel} ${styles.skelLine}`}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                    {!loading && error && (
                        <p className={styles.statusLine}>{error}</p>
                    )}
                    {!loading && !error && cards.length === 0 && (
                        <p className={styles.statusLine}>
                            No plans available right now.
                        </p>
                    )}

                    {!loading && cards.length > 0 && (
                        <div className={styles.plansList}>
                            {cards.map((card) => {
                                const isSelected = card.id === selectedPlanId;
                                const symbol = getCurrencySymbol(
                                    card.display?.currency
                                );
                                const onCardClick = () => {
                                    if (card.isCurrentPlan) {
                                        setError("This is your current plan.");
                                        return;
                                    }
                                    if (card.isDowngrade) {
                                        setError(
                                            "Downgrades aren't supported here. Please contact support@rxpt.us to switch to a lower tier."
                                        );
                                        return;
                                    }
                                    setError("");
                                    setSelectedPlanId(card.id);
                                    // GA4: a plan card was selected.
                                    trackEvent("select_plan", {
                                        plan: card.name,
                                        billing_cycle: billingInterval === "year" ? "yearly" : "monthly",
                                    });
                                };
                                return (
                                    <div
                                        key={card.id}
                                        // className={`${styles.planCard} ${isSelected
                                        //     ? styles.planCardSelected
                                        //     : ""
                                        //     }`}
                                        className={`${styles.planCard} ${isSelected ? styles.planCardSelected : ''} ${isSelected ? styles[`accent_${card.id}`] : ''} ${card.isLocked ? styles.planCardLocked : ''}`}
                                        onClick={onCardClick}
                                        style={card.isLocked ? { opacity: 0.55, cursor: "not-allowed" } : undefined}
                                        aria-disabled={card.isLocked || undefined}
                                    >
                                        {card.isCurrentPlan && (
                                            <span className={styles.lockedBadge} style={{ position: "absolute", top: 8, right: 12, fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 999, background: "#eef2ff", color: "#4f46e5" }}>
                                                Current Plan
                                            </span>
                                        )}
                                        {!card.isCurrentPlan && card.isDowngrade && (
                                            <span className={styles.lockedBadge} style={{ position: "absolute", top: 8, right: 12, fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 999, background: "#f3f4f6", color: "#6b7280" }}>
                                                Lower Tier
                                            </span>
                                        )}
                                        {card.recommended && (
                                            <span className={styles.recommendedTag}>
                                                <img src="/svg/recoomeded_shape.svg" alt="recoomeded_shape" />
                                            </span>
                                        )}
                                        <div className={styles.planTop}>
                                            <div className={styles.planLeft}>
                                                {card.icon && (
                                                    <img
                                                        src={card.icon}
                                                        alt={card.name}
                                                        className={styles.planIcon}
                                                        onError={(e) =>
                                                        (e.currentTarget.style.display =
                                                            "none")
                                                        }
                                                    />
                                                )}
                                                <div>
                                                    <h3
                                                        className={styles.planPrice}
                                                    >
                                                        {card.display ? (
                                                            <>
                                                                {symbol}
                                                                {formatPrice(
                                                                    card.display
                                                                        .amount
                                                                )}
                                                                /month
                                                            </>
                                                        ) : (
                                                            "—"
                                                        )}
                                                    </h3>
                                                    <p className={styles.planPer}>
                                                        Per Receptionist
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={styles.planRight}>
                                                <p className={styles.planMinutes}>
                                                    <strong>
                                                        {card.minutes
                                                            ? Number(
                                                                card.minutes
                                                            ).toLocaleString()
                                                            : "—"}
                                                    </strong>
                                                    <span>minutes</span>
                                                </p>
                                                <div className={styles.radioWrapper}>
                                                    <span
                                                        className={`${styles.radio} ${isSelected
                                                            ? styles.radioActive
                                                            : ""
                                                            }`}
                                                        aria-hidden="true"
                                                    >
                                                        {isSelected && (
                                                            <span
                                                                className={
                                                                    styles.radioCheck
                                                                }
                                                                aria-hidden="true"
                                                            >
                                                                <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M3.5 8L6.5 11L12.5 5"
                                                                        stroke="#fff"
                                                                        strokeWidth="2.4"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={styles.planMid}>
                                            <h4 className={styles.planName}>
                                                {(card.name || "").toUpperCase()}
                                            </h4>
                                            <button
                                                type="button"
                                                className={styles.featuresToggle}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    revealPlanFeatures(card);
                                                }}
                                            >
                                                See All Features{" "}
                                                <span
                                                    className={`${styles.featuresArrow} ${showComparison && selectedPlanId === card.id
                                                        ? styles.featuresArrowOpen
                                                        : ""
                                                        }`}
                                                    aria-hidden="true"
                                                >
                                                    {/* Down chevron — open hone par CSS 180° ghuma ke up bana deta hai. */}
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>

                                        {card.summary && (
                                            <p className={styles.planSummary}>
                                                {card.summary}
                                            </p>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {showComparison && cards.length > 0 && (
                        <div className={styles.compareTable} ref={comparisonRef}>
                            <div className={styles.compareHead}>
                                <span
                                    className={`${styles.compareHeadCell} ${selectedCard?.id === "starter"
                                        ? `${styles.compareHeadActive} ${styles.compareHeadActiveStarter}`
                                        : ""
                                        }`}
                                >
                                    STARTER
                                </span>
                                <span
                                    className={`${styles.compareHeadCell} ${selectedCard?.id === "scaler"
                                        ? `${styles.compareHeadActive} ${styles.compareHeadActiveScaler}`
                                        : ""
                                        }`}
                                >
                                    SCALE
                                </span>
                                <span
                                    className={`${styles.compareHeadCell} ${selectedCard?.id === "growth"
                                        ? `${styles.compareHeadActive} ${styles.compareHeadActiveGrowth}`
                                        : ""
                                        }`}
                                >
                                    GROWTH
                                </span>
                                <span
                                    className={`${styles.compareHeadCell} ${styles.comparePriceCell}`}
                                >
                                    {(() => {
                                        const c = cards.find(
                                            (cc) =>
                                                cc.id ===
                                                (selectedCard?.id || "starter")
                                        );
                                        if (!c?.display) return "—";
                                        return `${getCurrencySymbol(c.display.currency)}${formatPrice(
                                            c.display.amount
                                        )}`;
                                    })()}
                                </span>
                            </div>
                            {COMPARISON_ROWS.map((row) => (
                                <div className={styles.compareRow} key={row.label}>
                                    <div className={styles.compareLabelCell}>
                                        <strong>{row.label}</strong>
                                        {row.sub && (
                                            <span className={styles.compareSubText}>
                                                {row.sub}
                                            </span>
                                        )}
                                    </div>
                                    <div className={styles.compareValueCell}>
                                        {COMPARISON_COLUMNS.map((col, i) => {
                                            // Show the value for the column that
                                            // matches the highlighted card. Fall
                                            // back to scaler when no selection.
                                            const targetCol =
                                                selectedCard?.id || "scaler";
                                            if (col !== targetCol) return null;
                                            const v = row.cells[col];
                                            if (v === true)
                                                return (
                                                    <span
                                                        key={col}
                                                        className={
                                                            styles.compareTick
                                                        }
                                                        aria-label="Included"
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                            <path d="M3.5 8L6.5 11L12.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                );
                                            return (
                                                <span
                                                    key={col}
                                                    className={styles.compareText}
                                                >
                                                    {v}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}


                </div>

                <div className={styles.continueBar}>
                    <div className={styles.trustRow}>
                        <div className={styles.trustItem}>
                            <span
                                className={`${styles.trustBadge} ${styles.trustBadgeYellow}`}
                            >
                                <img src="/svg/rating_icon.svg" alt="rating_icon" />
                            </span>
                            <div>
                                <p className={styles.trustTitle}>4.9/5 from</p>
                                <p className={styles.trustSub}>136 Business</p>
                            </div>
                        </div>
                        <div className={styles.trustItem}>
                            <span
                                className={styles.trustBadge}
                            >
                                <img src="/svg/security_icon.svg" alt="security_icon" />
                            </span>
                            <div>
                                <p className={styles.trustTitle}>Bank-level</p>
                                <p className={styles.trustSub}>Security</p>
                            </div>
                        </div>
                        <div className={styles.trustItem}>
                            <span
                                className={styles.trustBadge}
                            >
                                <img src="/svg/fee_icon.svg" alt="fee_icon" />
                            </span>
                            <div>
                                <p className={styles.trustTitle}>No hidden fees</p>
                                <p className={styles.trustSub}>
                                    Transparent policy
                                </p>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        className={styles.continueBtn}
                        onClick={handleContinue}
                        disabled={!selectedCard || checkoutLoading}
                    >
                        <span className={styles.continueAvatar}>
                            <img
                                src="/svg/receptionist_profile.png"
                                alt={agentName}
                            />
                        </span>
                        <span className={styles.continueLeft}>
                            <span className={styles.continueLabel}>
                                Selected plan
                            </span>
                            <span className={styles.continuePlan}>
                                {selectedCard?.name || "—"}
                            </span>
                        </span>
                        <span className={styles.continueAction}>
                            {checkoutLoading ? "Redirecting…" : "Continue"}{" "}
                            {!checkoutLoading && (
                                <span className={styles.continueArrow} aria-hidden="true">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.33944 13.093L5.94953 11.7166L10.1125 7.55362H-0.00146484V5.54297H10.1125L5.94953 1.38672L7.33944 0.00355083L13.8842 6.5483L7.33944 13.093Z" fill="#6524eb" />
                                    </svg>
                                </span>
                            )}
                        </span>
                    </button>
                    <p className={styles.stripeFoot}>
                        <span className={styles.stripeLock} aria-hidden="true">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.63623 4.26727V2.29763C7.63623 1.03083 6.30398 0 4.66667 0C3.02935 0 1.6971 1.0308 1.6971 2.29763V4.26727C0.761574 4.26727 0 4.85648 0 5.58036V8.20598C0 8.92982 0.761529 9.51907 1.6971 9.51907H7.63623C8.57176 9.51907 9.33333 8.92986 9.33333 8.20598V5.58036C9.33333 4.85652 8.5718 4.26727 7.63623 4.26727ZM5.09057 7.54943C5.09057 7.72983 4.89975 7.87747 4.66659 7.87747C4.43344 7.87747 4.24261 7.72983 4.24261 7.54943V6.23634C4.24261 6.05594 4.43344 5.90829 4.66659 5.90829C4.89975 5.90829 5.09057 6.05594 5.09057 6.23634V7.54943ZM6.78768 4.26727H2.54566V2.29763C2.54566 1.39338 3.49801 0.656547 4.66667 0.656547C5.83532 0.656547 6.78768 1.39341 6.78768 2.29763V4.26727Z" fill="#635BFF" />
                            </svg>

                        </span>
                        <img
                            src="/svg/stripe_logo.svg"
                            alt="Stripe"
                            className={styles.stripeWord}
                        /> Secure
                        checkout. Cancel anytime.
                    </p>
                </div>
            </div>);
}
